import { SAVEDYNAMICFIELDS_SUCCESS, SAVEDYNAMICFIELDS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const saveDynamicFieldsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVEDYNAMICFIELDS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case SAVEDYNAMICFIELDS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default saveDynamicFieldsReducer;
